import * as React from "react";

const SvgCursorsPress = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#cursors_press_svg__a)">
      <g filter="url(#cursors_press_svg__b)">
        <path
          fill="currentColor"
          d="m7.962 13.667-1.015-1.505c-.693-1.028-2.168-1.403-3.297-.84l.263-.131a.627.627 0 0 0-.3.778l1.405 3.528c.223.56.792 1.35 1.263 1.748 0 0 2.825 2.27 2.825 3.122v1.077h4.579l1.144-2.222 1.145 2.222h1.144v-1.077c0-.852 1.727-3.533 1.727-3.533.318-.521.583-1.44.583-2.049v-4.483c-.02-.993-.89-1.797-1.962-1.797-.537 0-.971.402-.971.899v.359c0-.993-.87-1.797-1.942-1.797-.536 0-.97.402-.97.899v.359c0-.993-.87-1.797-1.942-1.797-.537 0-.971.402-.971.899v.359q0-.239-.052-.387l-.296-4.63c-.04-.626-.583-1.112-1.216-1.112-.636 0-1.144.497-1.144 1.11v10.001m8.032-1.111h1.145V17h-1.145zm-2.289 0h1.145V17h-1.145zm-2.289 0h1.145V17h-1.145z"
        />
      </g>
      <path
        fill="currentColor"
        fillOpacity={0.92}
        fillRule="evenodd"
        stroke="currentColor"
        d="M9.106 2c.467 0 .902.18 1.226.476.32.293.532.7.561 1.158l.213 3.328.019-.007q.161-.054.337-.074l.179-.01a2.6 2.6 0 0 1 1.915.829l.028.033.013-.01c.218-.162.485-.271.778-.303l.178-.01a2.6 2.6 0 0 1 1.915.829l.029.033.012-.01c.218-.162.485-.271.778-.303l.179-.01c.688 0 1.31.26 1.765.676A2.32 2.32 0 0 1 20 10.297v4.488c0 .694-.3 1.739-.663 2.332-.007.012-1.647 2.463-1.647 3.25V22h-2.07l-.791-1.535-.79 1.535H8.533v-1.633c0-.636-1.818-2.083-2.43-2.553l-.145-.11-.054-.04c-.53-.447-1.17-1.337-1.42-1.967L3.08 12.17a1.15 1.15 0 0 1-.002-.84c.104-.269.306-.499.573-.632l.008.014.234-.07c.6-.16 1.13-.165 1.62-.056l.209.054c.616.18 1.176.538 1.575 1.042l.092.133V3.666c0-.403.147-.772.392-1.06l.11-.119c.31-.3.739-.487 1.215-.487Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="cursors_press_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
      <filter
        id="cursors_press_svg__b"
        width={21.856}
        height={24.889}
        x={0.572}
        y={0.556}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7313_8263"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_7313_8263"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgCursorsPress;
